module.exports = __webpack_public_path__ + "img/qjxd2_TC_JP.d1113762.png";